import { useSite } from 'Shared/SiteProvider';
import {VenueSettingsFactory} from 'Shared/VenueSettingsFactory';
import { LabelOnLeftWrap, labelStyle } from 'Shared/forms/Wrap';
import { StylesField } from 'Shared/backend/widgets/Styles';
import { useStore, StoreProvider } from 'Shared/StoreProvider';
import { createSignal, createMemo, Show, Switch, Match, For } from 'solid-js';
import { Dynamic } from 'solid-js/web';
import { css } from '@emotion/css';
import { theme } from 'Shared/ThemeProvider';


export function StyleTags()
{
	const siteTheme = (new VenueSettingsFactory()).createSettings(useSite().key).siteTheme();

	const sw = useStore();

	const storePos = () => {
		let pos: any = sw.store;
		for (const part of (sw.location ?? [])) pos = pos?.[part];
		return pos;
	};

	const styles = createMemo(() => (storePos()?.styles ?? []) as any[]);

	const createParams = (previous, field, value) => ({
		...previous,
		[field]: value
	});

	const outerStyle = () => css({
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'end',
		marginBottom: '0.7em'
	});

	const paneStyle = () => css({
		width: 500
	});

	const linkWrapStyle = () => css({
		display: 'flex',
	});

	const linkStyle = () => css(theme().a);

	const [show,setShow] = createSignal(false);

	return (
		<div class={outerStyle()}>
			<div class={linkWrapStyle()}>
				<Switch>
					<Match when={show()}>
						<a class={linkStyle()} href='' onClick={() => setShow(false)}>Hide styles</a>
					</Match>
					<Match when={true}>
						<a class={linkStyle()} href='' onClick={() => setShow(true)}>Show styles</a>
					</Match>
				</Switch>
			</div>

			<Show when={show()}>
				<div class={paneStyle()}>
					<LabelOnLeftWrap label='Styles'>
						<StylesField styleDefinitions={siteTheme.styles} />
					</LabelOnLeftWrap>

					<For each={styles()}>{(style, index) => (
						<Show when={siteTheme.styles[style.type]?.ui}>
							<div>
								<label class={labelStyle()}>{style.type}:</label>
								<StoreProvider {...sw} location={[...(sw.location ?? []), 'styles', index(), 'params']} prepare={createParams}>
									<Dynamic component={siteTheme.styles[style.type].ui} />
								</StoreProvider>
							</div>
						</Show>
					)}</For>
				</div>
			</Show>
		</div>
	);
}

